import React from "react";

const ShowEyeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="show_eye_icon"
      data-name="show eye"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7.5C9.33831 7.50437 8.70496 7.76916 8.23706 8.23706C7.76916 8.70496 7.50437 9.33831 7.5 10C7.5 11.3683 8.63167 12.5 10 12.5C11.3675 12.5 12.5 11.3683 12.5 10C12.5 8.6325 11.3675 7.5 10 7.5Z"
        fill={props.fill || "#3A8AB9"}
      />
      <path
        d="M9.99943 4.16663C3.63859 4.16663 1.72693 9.68079 1.70943 9.73663L1.62109 9.99996L1.70859 10.2633C1.72693 10.3191 3.63859 15.8333 9.99943 15.8333C16.3603 15.8333 18.2719 10.3191 18.2894 10.2633L18.3778 9.99996L18.2903 9.73663C18.2719 9.68079 16.3603 4.16663 9.99943 4.16663ZM9.99943 14.1666C5.54026 14.1666 3.81276 10.9616 3.39443 9.99996C3.81443 9.03496 5.54276 5.83329 9.99943 5.83329C14.4586 5.83329 16.1861 9.03829 16.6044 9.99996C16.1844 10.965 14.4561 14.1666 9.99943 14.1666V14.1666Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default ShowEyeIcon;
